import { render } from "./ModalSymptomDetails.vue?vue&type=template&id=15e2bad8"
import script from "./ModalSymptomDetails.vue?vue&type=script&lang=js"
export * from "./ModalSymptomDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__